import React, { useEffect, useState } from "react";
import Highcharts, { solidGauge } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import more from "highcharts/highcharts-more";
import { FaSquareFull } from "react-icons/fa6";
import { Avatar, Box, Divider, Skeleton, styled, Typography, useTheme ,List, ListItem, ListItemIcon, ListItemText} from "@mui/material";
import { useGetEngineeringPlanVsActualQuery } from "store/slices/apis/engineeringDashboardSlice";
import { useParams } from "react-router-dom";

// Initialize modules
if (typeof more === "function") {
    more(Highcharts);
}

const PlanActualEngg = () => {
    const theme = useTheme();
     const [chartData, setChartData] = useState([]);
    const { projectId } = useParams();
    const { data, isLoading } = useGetEngineeringPlanVsActualQuery({ projectId });

   
   useEffect(() => {
           if (data) {   
               const { overallTarget, plannedPercentage, actualPercentage } = data;
   
               const updatedChartData = [
                   {
                       name: "Overall Progress",
                       data: [
                           {
                               y: overallTarget,
                               color: "#E9E3E3",
                               radius: "90%",
                               innerRadius: "100%",
                           },
                       ],
                   },
                   {
                       name: "Planned Progress",
                       data: [
                           {
                               y: plannedPercentage,
                               color: "#295477",
                               radius: "75%",
                               innerRadius: "85%",
                           },
                       ],
                   },
                   {
                       name: "Actual Progress",
                       data: [
                           {
                               y: actualPercentage,
                               color: actualPercentage >= plannedPercentage ? '#3E756D' : '#E72B33',
                               radius: "60%",
                               innerRadius: "70%",
                           },
                       ],
                   },
               ];
   
               setChartData(updatedChartData);
           }
       }, [data]);


     let options = {
           chart: {
               type: "solidgauge",
               height: 130,
               width: 130,
               backgroundColor: 'transparent'
           },
           title: {
               text: "",
               style: { fontSize: "18px" },
           },
           pane: {
               size: '100%',
               startAngle: 0,
               endAngle: 360,
               background: [
                   {
                       outerRadius: "",
                       innerRadius: "88%",
                       backgroundColor: Highcharts.color("#7cb5ec").setOpacity(0.3).get(),
                       borderWidth: 0,
                   },
                   {
                       outerRadius: "",
                       innerRadius: "63%",
                       backgroundColor: Highcharts.color("#90ed7d").setOpacity(0.3).get(),
                       borderWidth: 0,
                   },
                   {
                       outerRadius: "",
                       innerRadius: "38%",
                       backgroundColor: Highcharts.color("#f7a35c").setOpacity(0.3).get(),
                       borderWidth: 0,
                   },
               ],
           },
           yAxis: {
               min: 0,
               max: 100,
               lineWidth: 0,
               tickPositions: [],
           },
           plotOptions: {
               solidgauge: {
                   dataLabels: {
                       enabled: false,
                   },
                   linecap: "round",
                   stickyTracking: false,
               },
           },
           tooltip: {
               enabled: false
           },
           legend: {
               enabled: false,
               align: "center",
               verticalAlign: "bottom",
               layout: "horizontal",
           },
           series: chartData,
           credits: {
               enabled: false,
           },
       };


    return (
       <Box
            sx={{
                p: 2,
                width: "100%",
                height: "246px",
                maxWidth: "100%",
                minHeight: "100%",
                border: "1px solid #D8D8D8",
                mt: 0,
                borderRadius: "12px",
                overflow: "hidden",
                backgroundColor: "white",
            }}
        >
            <Box>
                <Typography
                    variant="body"
                    sx={{
                        fontWeight: 500,
                        fontSize: "18px",
                        lineHeight: "100%",
                        letterSpacing: "-0.4px",
                        color: `${theme?.customSettings?.themeColor}`,
                    }}
                >
                    Physical Progress - Plan vs Actual
                </Typography>
                <Typography
                    sx={{
                        mt: "5px",
                        color: "#5052588A",
                        fontWeight: 500,
                        fontSize: "14px",
                        lineHeight: "100%",
                        letterSpacing: "-0.4px",
                        mb:"22px"
                    }}
                >
                    Progress variance and  execution shortfalls against the project baseline
                </Typography>
            </Box>
            {isLoading ? (
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <List sx={{ padding: 0, mb: 4 }}>
                        {[1, 2, 3].map((_, i) => (
                            <ListItem key={i} sx={{ paddingLeft: 0 }}>
                                <Skeleton variant="circular" width={14} height={14} sx={{ mr: 1 }} />
                                <Skeleton variant="text" width={120} height={20} />
                            </ListItem>
                        ))}
                    </List>
                    <Skeleton variant="circular" width={130} height={130} />
                </Box>
            ) : chartData.length === 0 ||
                chartData.every(series => !series?.data?.[0]?.y && series?.data?.[0]?.y !== 0) ? (
                <Typography
                    sx={{
                        mt: 5,
                        textAlign: "center",
                        width: "100%",
                        fontSize: "16px",
                        color: "#999",
                    }}
                >
                    No record found
                </Typography>
            ) : (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <List sx={{ padding: 0, mb: 4 }}>
                        {chartData.map((val, index) => (
                            <ListItem key={index} sx={{ paddingLeft: 0 }}>
                                <ListItemIcon sx={{ minWidth: "20px" }}>
                                    <FaSquareFull
                                        style={{
                                            color: `${val?.data[0]?.color}`,
                                            height: "14px",
                                            width: "14px",
                                        }}
                                    />
                                </ListItemIcon>
                                <ListItemText
                                    primary={
                                        <>
                                            <Typography
                                                component="span"
                                                sx={{
                                                    whiteSpace: "nowrap",
                                                    fontWeight: 500,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "-0.4px",
                                                }}
                                            >
                                                {val?.name}:{" "}
                                            </Typography>
                                            <Typography
                                                component="span"
                                                sx={{
                                                    color: "#182A4E",
                                                    whiteSpace: "nowrap",
                                                    fontWeight: 500,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "-0.4px",
                                                }}
                                            >
                                                {val?.data[0]?.y}%
                                            </Typography>
                                        </>
                                    }
                                />
                            </ListItem>
                        ))}
                    </List>
                    <Box sx={{ flexShrink: 0 }}>
                        <HighchartsReact highcharts={Highcharts} options={options} />
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default PlanActualEngg;
